import { Check, Flag } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Accept and Concern decide the item in one click; Save note only appears
 * once a note is typed and keeps the item In review. */
export function ItemActions({
  title,
  busy,
  hasUnsavedNote,
  onAccept,
  onConcern,
  onSaveNote,
}: {
  title: string;
  busy: boolean;
  hasUnsavedNote: boolean;
  onAccept: () => void;
  onConcern: () => void;
  onSaveNote: () => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2 pt-1">
      <Button
        size="sm"
        disabled={busy}
        aria-label={`Accept ${title}`}
        onClick={onAccept}
      >
        <Check className="mr-1.5 size-4" aria-hidden />
        Accept
      </Button>
      <Button
        size="sm"
        variant="outline"
        disabled={busy}
        aria-label={`Concern ${title}`}
        onClick={onConcern}
      >
        <Flag className="mr-1.5 size-4" aria-hidden />
        Concern
      </Button>
      {hasUnsavedNote && (
        <Button
          size="sm"
          variant="surface"
          disabled={busy}
          aria-label={`Save note for ${title}`}
          onClick={onSaveNote}
        >
          Save note
        </Button>
      )}
    </div>
  );
}
